import React from 'react';
import { Box, Typography, Chip, useTheme } from '@mui/material';

interface ReadOnlyFieldProps {
  label: string;
  value?: React.ReactNode;
  multiline?: boolean;
  chips?: string[];
}

const ReadOnlyField: React.FC<ReadOnlyFieldProps> = ({ label, value, multiline, chips }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const hasValue = chips
    ? chips.length > 0
    : value !== undefined && value !== null && value !== '' && value !== '-';

  return (
    <Box sx={{ mb: 0.5 }}>
      <Typography
        variant="caption"
        sx={{
          color: theme.palette.text.secondary,
          fontWeight: 600,
          fontSize: '0.75rem',
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
        }}
      >
        {label}
      </Typography>

      {chips ? (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
          {chips.length > 0 ? (
            chips.map((chip, i) => (
              <Chip key={i} label={chip} size="small" variant="outlined" />
            ))
          ) : (
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontStyle: 'italic' }}>
              –
            </Typography>
          )}
        </Box>
      ) : (
        <Typography
          variant="body1"
          sx={{
            mt: 0.25,
            color: hasValue ? theme.palette.text.primary : theme.palette.text.secondary,
            fontStyle: hasValue ? 'normal' : 'italic',
            whiteSpace: multiline ? 'pre-wrap' : 'normal',
            wordBreak: 'break-word',
            lineHeight: 1.6,
          }}
        >
          {hasValue ? value : '–'}
        </Typography>
      )}
    </Box>
  );
};

export default ReadOnlyField;
